import request from '@/request'
//应用领域案例
export function getproject(params){
    return request({
        url:'anli?_sort=id&_order=DESC&_start=0&_end=20',
        params
    })
}
//获取新闻内容
export function getnews(params) {
    const { page , pageSize,type } = params || {};
    // 计算起始索引和结束索引
    const _start = (page - 1) * pageSize;
    const _end = page * pageSize;
    return request({
        method:'get',
        url:`Dontai?_sort=id&_order=DESC&_start=${_start}&_end=${_end}&type=${type}`,
    })
}
//获取产品系列
export function getSeries(){
    return request({
        url:'series?_sort=id&_order=DESC&_start=0&_end=20'
    })
}
//获取产品列表
export function getProduct(params) {
    const { page , pageSize,type } = params || {};
    // 计算起始索引和结束索引
    const _start = (page - 1) * pageSize;
    const _end = page * pageSize;
    // let baseUrl = `product?_sort=sort&_order=DESC&_start=${_start}&_end=${_end}`;
    let baseUrl = `product?_sort=sort&_order=DESC&_start=0&_end=100`;
  
  // 只有当 type 存在且不为空字符串时，才拼接 type 参数
    const fullUrl = type ? `${baseUrl}&type=${type}` : baseUrl;

    return request({
        url: fullUrl
     });
} 
//首页下方轮播图  
export function smallPicture(){
    return request({
        url:'engineering/byState'
    })
} 
//首页荣誉图片  
export function achievementPic(){
    return request({
        url:'achievementPic/list'
    })
} 
//首页荣誉图片  
export function honor(){
    return request({
        url:'zhishi?_sort=id&_order=DESC&_start=0&_end=20',
        method:'get'
    })
} 
//首页大轮播图
export function getBannerList(){
    return request({
        method:'get',
        url:'fengmian?_sort=id&_order=DESC&_start=0&_end=20'
    })
} 
//新闻详情
export function newsdetail(params){
    return request({
        url:'article/articleDetails',
        params
    })
} 
//官网公司荣誉展示
export function honorList(params) {
    return request({
        url: '/honor/list',
        params
    })
}
//留言
export function message(params) {
    return request({
        url: '/messageBoard/create',
        method: 'post',
        data: params
    })
}
//工程详情
export function projectdetail(params){
    return request({
        url:'/engineering/details',
        params
    })
}
//企业文化
export function culture(){
    return request({
        url:'/organization/list'
    })
}
//荣誉详情
export function honordetail(params){
   return request({
    url:'/honor/byId',
    params
   })
}
//公司简介
export function compony(){
    return request({
        url: '/aboutus?_sort=id&_order=DESC&_start=0&_end=20',
        method: 'get'
    })
}
//新闻资讯
export function getmsg(params){
    return request({
        url:'/article/newsInformationList',
        params
    })
}
//新闻详情
export function msgdetail(params){
    return request({
        url:'/article/articleDetails',
        params
    })
} 
//新闻详情
export function getcruit(){
    return request({
        url:'/recruit/list'
    })
} 
//联系我们
export function concatinfo(){
    return request({
        url:'/contactus/list '
    })
} 
//联系我们
export function componyhonor(){
    return request({
        url:'/honorTitle/list '
    })
} 
//首页企业新闻
export function indexNews(params){
    return request({
        url:'/article/enterpriseNews',
        params
    })
} 
//首页企业新闻
export function indexInformation(params){
    return request({
        url:'/article/newsInformation',
        params
    })
} 
//首页新闻分类
export function NewCategary(){
    return request({
        url:'/articleType/list'
    })
} 

// 首页产品
export function projuct(){
	return request({
		url:'/product/list',
		method: 'get'
	})
}

// 首页产品类型
export function productType(){
	return request({
		url:'/productType/list',
		method: 'get'
	})
}

// 首页产品类型数据
export function byProductTypeList(params){
	return request({
		url:'/product/byProductTypeList',
		method: 'get',
		params
	})
}

// 首页最新动态
export function article(){
	return request({
		url:'/article/list',
		method: 'get'
	})
}

// 首页最新动态详情
export function articleDetails(params){
	return request({
		url:'/article/articleDetails',
		method: 'get',
		params
	})
}

// 首页最新动态详情
export function productDetails(params){
	return request({
		url:'/product/productDetails',
		method: 'get',
		params
	})
}

// 新闻资讯分类
export function articleType(params){
	return request({
		url:'/articleType/list',
		method: 'get',
		params
	})
}

// 新闻资讯列表
export function byArticleTypeList(params){
	return request({
		url:'/article/byArticleTypeList',
		method: 'get',
		params
	})
}
